export default {
      id: "jobs-application-usage",
      viewBox: "0 0 85 79",
      url: "../dist/images/" + "sprite.svg#jobs-application-usage",
      toString: function () {
        return this.url;
      }
    }